/* Cart indicator — retains Shopify native /cart link */
(() => {
 function initialize() {
  const links=[...document.querySelectorAll('[data-cr2-cart-link]')];
  if(!links.length)return;
  const rootPath=(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  let sequence=0;
  async function synchronize(){
   const run=++sequence;
   try{
    const res=await fetch(rootPath+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!res.ok)return;
    const data=await res.json();
    if(run!==sequence)return;
    const count=Number.isFinite(data.item_count)?data.item_count:0;
    links.forEach(link=>{
     const badge=link.querySelector('[data-cr2-cart-count]');
     if(badge){badge.textContent=count>99?'99+':String(count);badge.dataset.empty=count===0?'true':'false';}
     link.setAttribute('aria-label','Voir le panier, '+count+' '+(count===1?'article':'articles'));
    });
   }catch(_){/* Keep server-rendered cart count */}
  }
  document.addEventListener('cart:refresh',synchronize);
  window.addEventListener('pageshow',synchronize);
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')synchronize()});
  synchronize();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
 else initialize();
})();